import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-cookbook-video/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-cookbook-video/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-cookbook-video/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-cookbook-video/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-cookbook-video/detail',
    method: 'get',
    params: { id }
  })
}
export function putTop(params) {
  return request({
    url: '/cooking/cooking-cookbook-video/zd',
    method: 'get',
    params
  })
}
